import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {TtmTicket} from '../classes/ttm-ticket.class';
import { User } from '../classes/user';
import { TtmTicketStatus } from '../classes/ttm-ticket-status';

@Injectable({
    providedIn: 'root'
})
export class TtmTicketService {
    private baseUrl = 'ttm-tickets';

    constructor(private apiService: ApiService) {
    }


    getTickets(orderBy?: string, orderDirection?: string, search?: string, skip = 0, limit = 6, assigneeId?: number) {
        let params = {};
        if (orderBy) {
            params = {orderBy, orderDirection};
        }
        if (search) {
            params = {...params, search};
        }
        if (assigneeId) {
            params = {...params, assigneeId};
        }
        return this.apiService.getCall$<TtmTicket[]>(`${this.baseUrl}/list/${limit}/${skip}`, params);
    }

    getTicket(id: number) {
        return this.apiService.getCall$<TtmTicket>(`${this.baseUrl}/${id}`);
    }

    saveTicket(ticketData: TtmTicket) {
        return this.apiService.postCall$<TtmTicket>(`${this.baseUrl}`, ticketData);
    }

    deleteTicket(id: number) {
        return this.apiService.deleteCall$<void>(`${this.baseUrl}/${id}`);
    }

    updateTicket(id: number, ticketData: TtmTicket) {
        return this.apiService.putCall$<TtmTicket>(`${this.baseUrl}/${id}`, ticketData);
    }

    addComment(ticketId: number, text: string) {
        return this.apiService.postCall$<any>(`${this.baseUrl}/${ticketId}/comments`, { text });
    }

    deleteComment(ticketId: number, commentId: number) {
        return this.apiService.deleteCall$<void>(`${this.baseUrl}/${ticketId}/comments/${commentId}`);
    }

    getAllUsersRelatedToTickets() {
        return this.apiService.getCall$<User[]>(`${this.baseUrl}/users/list`);
    }

    getTicketStatuses() {
        return this.apiService.getCall$<TtmTicketStatus[]>(`${this.baseUrl}/statuses/list`);
    }

    getTicketsByStatus(status: string) {
        return this.apiService.getCall$<TtmTicket[]>(`${this.baseUrl}/status/${status}`);
    }

    muteNotifications(ticketId: number) {
        return this.apiService.postCall$<any>(`${this.baseUrl}/${ticketId}/mute`, {});
    }

    unmuteNotifications(ticketId: number) {
        return this.apiService.postCall$<any>(`${this.baseUrl}/${ticketId}/unmute`, {});
    }

    getAssignees() {
        return this.apiService.getCall$<User[]>(`${this.baseUrl}/assignees/list`);
    }
}
